<template>
 <div class="container" v-if="!isEdit || (isEdit && surveyModel.name != '')">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>account_circle</md-icon>
        </div>
        <h4 class="title">{{isEdit ? $t('survey.create.edit') : $t('survey.create.create')}}</h4>
      </md-card-header>

      <md-card-content>
        <!-- Name -->
        <md-field :class="{'md-error': $v.surveyModel.name.$error && $v.surveyModel.name.$invalid, 'md-valid': !$v.surveyModel.name.$error && !$v.surveyModel.name.$invalid}">
          <label>{{$t('survey.create.name')}}</label>
          <md-input v-model.trim="$v.surveyModel.name.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.surveyModel.name.$error && $v.surveyModel.name.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.surveyModel.name.$error && !$v.surveyModel.name.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- Question Text -->
        <md-field :class="{'md-error': $v.surveyModel.questionText.$error && $v.surveyModel.questionText.$invalid, 'md-valid': !$v.surveyModel.questionText.$error && !$v.surveyModel.questionText.$invalid}">
          <label>{{$t('survey.create.questionText')}}</label>
          <md-input v-model.trim="$v.surveyModel.questionText.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.surveyModel.questionText.$error && $v.surveyModel.questionText.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.surveyModel.questionText.$error && !$v.surveyModel.questionText.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- Duration Seconds -->
        <md-field :class="{'md-error': $v.surveyModel.defaultDurationSeconds.$error && $v.surveyModel.defaultDurationSeconds.$invalid, 'md-valid': !$v.surveyModel.defaultDurationSeconds.$error && !$v.surveyModel.defaultDurationSeconds.$invalid}">
          <label>{{$t('survey.create.durationSeconds')}}</label>
          <md-input type="number" v-model.trim="$v.surveyModel.defaultDurationSeconds.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.surveyModel.defaultDurationSeconds.$error && $v.surveyModel.defaultDurationSeconds.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.surveyModel.defaultDurationSeconds.$error && !$v.surveyModel.defaultDurationSeconds.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- Answer 1 -->
        <md-field :class="{'md-error': $v.surveyModel.answerText01.$error && $v.surveyModel.answerText01.$invalid, 'md-valid': !$v.surveyModel.answerText01.$error && !$v.surveyModel.answerText01.$invalid}">
          <label>{{$t('survey.create.answer1')}}</label>
          <md-input v-model.trim="$v.surveyModel.answerText01.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.surveyModel.answerText01.$error && $v.surveyModel.answerText01.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.surveyModel.answerText01.$error && !$v.surveyModel.answerText01.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- Answer 2 -->
        <md-field :class="{'md-error': $v.surveyModel.answerText02.$error && $v.surveyModel.answerText02.$invalid, 'md-valid': !$v.surveyModel.answerText02.$error && !$v.surveyModel.answerText02.$invalid}">
          <label>{{$t('survey.create.answer2')}}</label>
          <md-input v-model.trim="$v.surveyModel.answerText02.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.surveyModel.answerText02.$error && $v.surveyModel.answerText02.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.surveyModel.answerText02.$error && !$v.surveyModel.answerText02.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- Answer 3 -->
        <md-field :class="{'md-error': $v.surveyModel.answerText03.$error && $v.surveyModel.answerText03.$invalid, 'md-valid': !$v.surveyModel.answerText03.$error && !$v.surveyModel.answerText03.$invalid}">
          <label>{{$t('survey.create.answer3')}}</label>
          <md-input v-model.trim="$v.surveyModel.answerText03.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.surveyModel.answerText03.$error && $v.surveyModel.answerText03.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.surveyModel.answerText03.$error && !$v.surveyModel.answerText03.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- Answer 4 -->
        <md-field :class="{'md-valid': !$v.surveyModel.answerText04.$error && !$v.surveyModel.answerText04.$invalid}">
          <label>{{$t('survey.create.answer4')}}</label>
          <md-input v-model.trim="$v.surveyModel.answerText04.$model"></md-input>
        </md-field>
        <!-- Code -->
        <md-field :class="{'md-valid': !$v.surveyModel.code.$error && !$v.surveyModel.code.$invalid}">
          <label>{{$t('survey.create.code')}}</label>
          <md-input v-model.trim="$v.surveyModel.code.$model"></md-input>
        </md-field>

        <div class="controls">
          <md-button @click="createSurvey()" class="md-info">
            {{isEdit ? $t('survey.create.edit') : $t('survey.create.create')}}
          </md-button>
          <md-button v-if="isEdit" @click="removeSurvey()" class="md-danger">
            {{$t("survey.create.remove")}}
          </md-button>
        </div>
      </md-card-content>
    </md-card>
 </div>
</template>

<script>
import { required, email, sameAs } from 'vuelidate/lib/validators';
import { SlideYDownTransition } from "vue2-transitions";
import { mapState } from 'vuex';

export default {
  components: {
    SlideYDownTransition
  },
  computed: {
    ...mapState({
      templates: state => state.SurveyModule.templates
    })
  },
  data() {
    return {
      isEdit: false,
      surveyModel: {
        name: "",
        questionText: "",
        defaultDurationSeconds: null,
        answerText01: null,
        answerText02: null,
        answerText03: null,
        answerText04: null,
        code: null
      }
    }
  },
  mounted() {
    if (this.templates.length == 0) this.$store.dispatch('getTemplates')
    if (this.$route.params.id != undefined) {
      this.isEdit = true
      this.surveyModel = this.templates.find(template => template.id == this.$route.params.id)
    }
  },
  methods: {
    async createSurvey() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.isEdit) {
          const response = await this.$store.dispatch("updateTemplate", this.surveyModel)
          if (response != undefined) {
            this.$notify({
              message: this.$t(`notifications.survey.update`),
              icon: 'add_alert',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success'
            })
          } else {
            this.$store.dispatch("openModalError")
          }
        } else {
          const response = await this.$store.dispatch("createTemplate", this.surveyModel)
          if (response != undefined) {
            this.$notify({
              message: this.$t(`notifications.survey.create`),
              icon: 'add_alert',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success'
            })
          } else {
            this.$store.dispatch("openModalError")
          }
        }
        this.$router.push('/list/survey')
      }
    },
    async removeSurvey() {
      const response = await this.$store.dispatch("deleteTemplate", {templateId: Number(this.$route.params.id)})
      if (response != undefined) {
        this.$notify({
          message: this.$t(`notifications.survey.remove`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
      } else {
        this.$store.dispatch("openModalError")
      }
      this.$router.push('/list/survey')
    }
  },
  validations: {
    surveyModel: {
      name: {
        required
      },
      questionText: {
        required
      },
      defaultDurationSeconds: {
        required
      },
      answerText01: {
        required
      },
      answerText02: {
        required
      },
      answerText03: {
        required
      },
      answerText04: {},
      code: {}
    }
  },
  watch: {
    $route(to, from) {
      this.$router.go()
    }
  }
}
</script>

<style scoped>
  .controls {
    display: flex;
    justify-content: space-between;
  }
</style>>